module.exports = __webpack_public_path__ + "img/sy_gwhd1@3x.ae59c958.png";